import { createFileRoute, redirect } from "@tanstack/react-router";

// The dashboard API has no vintage data, so the tab is gone; old links land on
// the overview instead of a not-found page.
export const Route = createFileRoute("/_layout/portfolio/vintage")({
	beforeLoad: ({ search }) => {
		throw redirect({ to: "/portfolio/overview", search, replace: true });
	},
});
